import { TabpanelScrollContainerTestIdSuffix } from '~src/spacesPlatform/style/SpaceContainerStyles';

import { cssClass } from '../../style';

export namespace AuthorizableTypeSelectorStyles {
  const AuthorizableTypeSelectorCssPrefix = 'AuthorizableTypeSelector';

  export const titleMarginBottom = 18;
  export const tabsHeight = 36;
  export const tabsMarginTop = 20;
  export const tabsMarginBottom = 20;

  export const Container = cssClass(AuthorizableTypeSelectorCssPrefix, 'container', {
    display: 'flex',
    width: '100%',
    paddingTop: `${tabsMarginTop}px`,
  });

  export const TabsContainer = cssClass(AuthorizableTypeSelectorCssPrefix, 'tabs-container', {
    // marginBottom: '20px',
    // marginLeft: `${PermissionsGridStyles.GranteeCellWidth}px`,
    // marginTop: `${titleMarginBottom}px`,
    flex: 1,
    $nest: {
      [`& [data-tb-test-id$="${TabpanelScrollContainerTestIdSuffix}"]`]: {
        padding: '0px !important',
      },
      '& [role="tablist"]': {
        height: `${tabsHeight}px !important`,
        // width: `790px`,
      },
    },
    // display: 'flex',
  });

  export const TabsOverflowButton = cssClass(AuthorizableTypeSelectorCssPrefix, 'overflow-button', {
    // TFSID 1372812: Currently there is no widget to handle "tabs overflow", so this is a short term solution from UX.
    // Clicking on the final tab opens a dropdown menu under the tab. To position this dropdown, a DropdownButton
    // has to be located next to the tab (and be the same height as the tab as well as have some width).
    // However the DropdownButton itself should be effectively invisible - so this CSS removes all colors and makes it not-tabbable.
    $nest: {
      ':hover': {
        boxShadow: 'unset !important',
        backgroundColor: 'unset !important',
        cursor: 'unset',
      },
      ':focus': {
        boxShadow: 'unset !important',
        backgroundColor: 'unset !important',
        cursor: 'unset',
      },
      'button': {
        cursor: 'initial !important',
        height: `${tabsHeight}px`,
        margin: 'auto',
        width: `${1}px`,
        $nest: {
          ':hover': {
            boxShadow: 'none',
            backgroundColor: 'none',
            cursor: 'initial',
          },
        },
      },
      '& [role="presentation"]': {
        display: 'none',
      },
      // W-21818553: hide the ArrowTriangleDownIcon that DropdownButton renders by default —
      // the ▾ prefix in the "More" tab label already conveys the dropdown affordance, so the
      // extra icon is redundant.
      '& svg[data-tb-test-id="tb-icons-ArrowTriangleDownIcon"]': {
        display: 'none',
      },
    },
  });
}

